import React from "react";
import { Box, Typography } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import AppButton from "../common/AppButton";

interface NoSupplierListFoundProps {
  onAddClick?: () => void;
}

const NoSupplierListFound: React.FC<NoSupplierListFoundProps> = ({
  onAddClick
}) => {
  const { t } = useKivunovaTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      gap={3}
    >
      <Typography variant="h6" color="text.primary" fontWeight="bold">
        {t("no-suppliers-found", "No suppliers found")}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t(
          "no-suppliers-description",
          "Get started by adding your first supplier"
        )}
      </Typography>
      {onAddClick && (
        <Box>
          <AppButton variant="primary" onClick={onAddClick}>
            {t("add-supplier", "Add Supplier")}
          </AppButton>
        </Box>
      )}
    </Box>
  );
};

export default NoSupplierListFound;
